// Extensions
import { Service } from "../service";

import dayjs from "dayjs";
// import { i18n } from "../i18n";

// import "dayjs/locale/ru";
import "dayjs/locale/en";
import "./customRuLocale";

import relativeTime from "./customRelativeTimePlugin";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

export default dayjs;

export class Dayjs extends Service {
  static property = "dayjs";

  init(root, Vue) {
    // dayjs.locale(i18n.locale);
    dayjs.locale("ru");

    Vue.prototype.$dayjs = dayjs;

    Vue.filter("dayjs", (date, format) => {
      if (date.toString().length < 12) {
        date = date * 1000;
      }
      return dayjs(date).format(format);
    });

    Vue.filter("dayjsFromNow", date => {
      if (date.toString().length < 12) {
        date = date * 1000;
      }
      return dayjs(date).fromNow();
    });

    // Переопределю параметр в $core.dayjs, чтоб возвращало не этот класс, а функцию
    this.framework[Dayjs.property] = dayjs;
  }
}
